// import { showAlert } from './alerts.js';

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  console.log('from js_heart');
  // ------------------------------------------------------------
  // 🔥 Cached Intl.NumberFormat – avoid recreating on each format
  // ------------------------------------------------------------
  const priceFormatter = new Intl.NumberFormat('fr-FR');

  // ------------------------------------------------------------
  // API helpers – centralised error handling and like logic
  // ------------------------------------------------------------
  async function toggleLike(type, id, likeId, isLiked) {
    try {
      let response;
      if (!isLiked) {
        // Add like
        response = await axios.post(`/api/v1/${type}s/${id}/likes`, {
          belongsTo: type === 'product' ? 'Product' : 'Store',
        });
      } else {
        // Delete like
        const url = likeId
          ? `/api/v1/${type}s/${id}/likes/${likeId}`
          : `/api/v1/${type}s/${id}/likes`;
        response = await axios.delete(url);
      }
      return { success: true, data: response.data };
    } catch (err) {
      showAlert('danger', 'Alert', err.response?.data?.message || 'Erreur');
      return { success: false };
    }
  }

  // ------------------------------------------------------------
  // Price formatting – batched & mutation-aware
  // ------------------------------------------------------------
  const formatPriceElement = el => {
    // Skip if already formatted or no price text
    if (el.dataset.formatted === 'true') return;
    const raw = el.innerText.replace(/\s/g, '');
    const price = parseFloat(raw);
    if (!isNaN(price)) {
      el.innerText = priceFormatter.format(price);
      el.dataset.formatted = 'true';
    }
  };

  const formatPrices = (root = document) => {
    root.querySelectorAll('.price').forEach(formatPriceElement);
  };

  // Initial format
  formatPrices();

  // Observe DOM changes for newly added prices, including characterData changes
  const observer = new MutationObserver(mutations => {
    // Batch formatting to avoid layout thrash
    requestAnimationFrame(() => {
      for (const mutation of mutations) {
        // Handle added nodes
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('.price')) formatPriceElement(node);
          node.querySelectorAll?.('.price').forEach(formatPriceElement);
        });

        // Handle text changes in existing price elements
        if (mutation.type === 'characterData') {
          const el = mutation.target.parentElement;
          if (el?.matches?.('.price')) formatPriceElement(el);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // ------------------------------------------------------------
  // Loader overlay (using CSS classes for better performance)
  // ------------------------------------------------------------
  // const loader = document.getElementById('loader_wrapper');
  // if (loader) {
  //   const showLoader = () => loader.classList.add('is-visible');
  //   const hideLoader = () => loader.classList.remove('is-visible');

  //   window.addEventListener('beforeunload', showLoader, { passive: true });
  //   window.addEventListener('pageshow', hideLoader);
  // }

  // ------------------------------------------------------------
  // Loader overlay
  // ------------------------------------------------------------
  // ------------------------------------------------------------
  // Navigation Loader (optimised for all browsers, including iOS)
  // ------------------------------------------------------------
  // 📦 Usage
  // Add this code to your main JavaScript bundle or inline it after the #loader_wrapper element exists.

  // If you have other interactive elements inside links (e.g., “Add to cart” buttons), give them the data-no-loader attribute:

  // html
  // <button data-no-loader>Add to cart</button>
  // The loader will only show for genuine link clicks that navigate to another page on the same domain.
  (function () {
    const loader = document.getElementById('loader_wrapper');
    if (!loader) return;

    let hideTimeout = null;

    const showLoader = () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
      loader.classList.add('is-visible');
      // Safety net: hide after 10 seconds if something goes wrong
      hideTimeout = setTimeout(hideLoader, 10000);
    };

    const hideLoader = () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
      loader.classList.remove('is-visible');
    };

    // ------------------------------------------------------------
    // 1. Handle link clicks (with skip for interactive elements)
    // ------------------------------------------------------------
    document.addEventListener('click', event => {
      // console.log('reached here :', event.target.closest('.heart'));
      // --- SKIP: clicks on buttons, hearts, or elements with data-no-loader ---
      if (
        event.target.closest('button, .heart, .no-loader, [data-no-loader]')
      ) {
        // console.log('reached here 2 ');
        return; // Do NOT show the loader
      }

      const link = event.target.closest('a');
      if (!link) return;

      // Ignore modified clicks (new tab/window) and middle‑click
      if (
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button === 1
      ) {
        return;
      }

      // Ignore links that don't trigger a full page navigation
      if (
        link.target === '_blank' ||
        link.hasAttribute('download') ||
        !link.getAttribute('href') ||
        link.getAttribute('href').startsWith('#') ||
        link.getAttribute('href').startsWith('javascript:')
      ) {
        return;
      }

      // Only same‑origin navigation
      if (link.origin !== window.location.origin) {
        return;
      }

      showLoader();
    });

    // ------------------------------------------------------------
    // 2. Handle form submissions
    // ------------------------------------------------------------
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form.target === '_blank') return;

      // Check if form action is same‑origin
      const action = form.getAttribute('action') || window.location.href;
      try {
        const url = new URL(action, window.location.origin);
        if (url.origin !== window.location.origin) return;
      } catch {
        return;
      }

      showLoader();
    });

    // ------------------------------------------------------------
    // 3. Handle beforeunload (desktop / Android)
    // ------------------------------------------------------------
    // window.addEventListener('beforeunload', event => {
    //   const target = event.target;
    //   if (
    //     target &&
    //     typeof target.closest === 'function' &&
    //     target.closest('button, .heart, .no-loader, [data-no-loader]')
    //   ) {
    //     return;
    //   }

    //   showLoader();
    // });
    // ------------------------------------------------------------
    // 3. Handle beforeunload (desktop / Android)
    // ------------------------------------------------------------
    // The `beforeunload` event target is always `window`. To conditionally skip the
    // loader, we track clicks on excluded elements and set a temporary flag.
    let shouldSkipLoader = false;

    // Capture clicks (supports mouse, touch, and keyboard Enter/Space).
    // Using capture phase (`true`) ensures this runs before any delegated handlers.
    document.addEventListener(
      'click',
      event => {
        const target = event.target;
        // Check if the clicked element (or its parent) matches the skip selectors
        if (target?.closest?.('button, .heart, .no-loader, [data-no-loader]')) {
          shouldSkipLoader = true;

          // Reset the flag after a short delay. This prevents stale flags if:
          // 1. The user clicks a "skip" button but navigation is canceled (e.g., `e.preventDefault()`).
          // 2. The user clicks a skip element that doesn't trigger a full page unload.
          // 3. A subsequent, unrelated unload happens later.
          setTimeout(() => {
            shouldSkipLoader = false;
          }, 300);
        }
      },
      { capture: true, passive: true }
    ); // `passive` improves scrolling performance.

    window.addEventListener('beforeunload', () => {
      // If the flag is true, skip showing the loader and immediately reset the flag.
      if (shouldSkipLoader) {
        shouldSkipLoader = false; // Consume the flag
        return;
      }

      showLoader();
    });
    // ------------------------------------------------------------
    // 4. Handle pageshow (back/forward cache, iOS)
    // ------------------------------------------------------------
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        hideLoader(); // bfcache restore → hide immediately
      } else {
        // Normal load: delay a frame to avoid flash
        requestAnimationFrame(() => setTimeout(hideLoader, 50));
      }
    });

    // ------------------------------------------------------------
    // 5. Fallback for iOS reloads (beforeunload may not fire)
    // ------------------------------------------------------------
    window.addEventListener('load', () => {
      const nav = performance.getEntriesByType('navigation');
      if (nav.length && nav[0].type === 'reload') {
        showLoader();
        setTimeout(hideLoader, 100);
      }
    });

    // ------------------------------------------------------------
    // 6. Extra safety: hide on visibility change (user switches tabs)
    // ------------------------------------------------------------
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && !document.hasFocus()) {
        // If the page becomes visible but not focused, hide stuck loader
        hideLoader();
      }
    });

    // ------------------------------------------------------------
    // 7. Expose helper to manually hide loader (optional)
    // ------------------------------------------------------------
    window.hideNavigationLoader = hideLoader;
  })();
  // ------------------------------------------------------------
  // Global heart click handler (event delegation)
  // ------------------------------------------------------------
  document.addEventListener('click', async function (e) {
    const heart = e.target.closest('.heart');
    if (!heart) return;

    e.preventDefault();
    e.stopPropagation();

    // Prevent double clicks
    if (heart.dataset.locked === 'true') return;
    heart.dataset.locked = 'true';
    const productId = heart.dataset.productId;

    const wasActive = heart.classList.contains('is-active');
    const type = heart.dataset.type; // "product" or "store"
    const itemId =
      type === 'product' ? heart.dataset.productId : heart.dataset.storeId;
    const likeId = heart.dataset.like || null;
    const likesCountEl = heart.parentElement?.querySelector('.likesCount');
    const currentLikes = likesCountEl ? Number(likesCountEl.textContent) : null;

    // Optimistic UI update
    heart.classList.toggle('is-active');
    if (likesCountEl) {
      likesCountEl.textContent = wasActive
        ? currentLikes - 1
        : currentLikes + 1;
    }

    try {
      const result = await toggleLike(type, itemId, likeId, wasActive);
      if (result.success) {
        // console.log(result.data);
        // Update likeId if returned
        if (!wasActive && result.data?.data?._id) {
          heart.dataset.like = result.data.data._id;
        } else if (wasActive) {
          heart.removeAttribute('data-like');
        }
        // Show success message
        const message =
          type === 'product'
            ? wasActive
              ? 'Article supprimé de vos souhaits !'
              : 'Article ajouté à vos préférés !'
            : wasActive
              ? 'Boutique retirée de vos préférés !'
              : 'Boutique ajoutée à vos préférés !';
        showAlert('success', 'Success', message);
      } else {
        // Rollback UI on failure
        heart.classList.toggle('is-active');
        if (likesCountEl) {
          likesCountEl.textContent = wasActive
            ? currentLikes
            : currentLikes - 1;
        }
      }
    } finally {
      // Always unlock
      heart.dataset.locked = 'false';
    }
  });
});
